import "./style.css";

export default class ArticleMember {
  static selector = ".article__member";
  constructor(block) {
    this.block = block;

    this.emailButton = this.block.querySelector(
      ".article__member__message button"
    );
  }

  handleEmailButtonClick = async () => {
    if (!window.App.modals.TalkToUsModal) {
      return;
    }

    await window.App.modals.TalkToUsModal.open();

    if (this.emailButton.dataset.contact) {
      window.App.modals.TalkToUsModal.update({
        contact: this.emailButton.dataset.contact
      });
    }
  };

  onReady = () => {
    this.emailButton.addEventListener("click", this.handleEmailButtonClick);
  };

  onDestroy = () => {
    this.emailButton.removeEventListener("click", this.handleEmailButtonClick);
  };
}
